<template>
	<div class="fic-detail">
		<div v-if="intestazione" class="fic-head">
			<v-avatar size="20px" tile class="mr-1">
				<img :src="require('@/assets/images/fattureincloud_active.svg')" alt="Fatture in cloud" />
			</v-avatar>
			<span class="fic-head-title">Configurazione Fatture in Cloud</span>
			<span class="fic-muted ml-2">{{ modello.active ? 'attivo' : 'disattivato' }}</span>
		</div>

		<div class="fic-body">
			<v-alert outlined text dense type="info" class="text-body-2 mb-4">
				Configurare il Redirect URL dell'app inserendo il seguente url <b class="fic-url">https://api.azseller.app/api/v1/nocors/fattureincloud/oauth/code</b>.
			</v-alert>

			<div class="fic-section">Credenziali app</div>
			<div class="fic-grid">
				<v-text-field v-model="setting.clientId" label="Client ID" dense outlined hide-details background-color="white" />
				<v-text-field
					v-model="setting.clientSecret"
					:type="mostraSecret ? 'text' : 'password'"
					:append-icon="mostraSecret ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
					label="Client Secret"
					autocomplete="new-password"
					dense
					outlined
					hide-details
					background-color="white"
					@click:append="mostraSecret = !mostraSecret"
				/>
				<div class="fic-full d-flex align-center">
					<v-select
						v-model="setting.id"
						:items="setting.companies"
						item-value="id"
						:item-text="item => item.name + ' ' + item.vat_number"
						label="Azienda"
						dense
						outlined
						hide-details
						background-color="white"
					/>
					<v-btn icon small class="ml-2" title="Aggiorna l'elenco delle aziende" @click="$emit('refresh-companies')">
						<v-icon color="primary">mdi-refresh</v-icon>
					</v-btn>
				</div>
			</div>

			<div class="fic-section mt-4">Associa IVA</div>
			<div v-if="!iva.length" class="fic-muted fic-small">Nessuna aliquota da associare.</div>
			<div v-else class="fic-grid">
				<v-select
					v-for="i in iva"
					:key="'iva' + i.name"
					v-model="i.code"
					:items="setting.vat_type"
					item-value="id"
					:item-text="item => '(' + item.value + ') ' + item.description"
					:label="'IVA ' + i.name + ' %'"
					dense
					outlined
					hide-details
					background-color="white"
				/>
			</div>

			<div class="fic-section mt-4">Associa pagamenti</div>
			<div v-if="!pagamenti.length" class="fic-muted fic-small">Nessun metodo di pagamento da associare.</div>
			<div v-else class="fic-grid">
				<v-select
					v-for="p in pagamenti"
					:key="'pay' + p.name"
					v-model="p.code"
					:items="setting.payment_account"
					item-value="id"
					item-text="name"
					:label="p.name"
					dense
					outlined
					hide-details
					background-color="white"
				/>
			</div>

			<div class="fic-section mt-4">Trasporto</div>
			<div class="fic-grid">
				<v-select
					v-model="setting.trasportoiva"
					:items="setting.vat_type"
					item-value="id"
					:item-text="item => '(' + item.value + ') ' + item.description"
					label="IVA trasporto"
					dense
					outlined
					hide-details
					background-color="white"
				/>
			</div>

			<div class="fic-section mt-4">Corrispettivi</div>
			<div class="fic-grid">
				<div class="fic-switch">
					<span>Corrispettivi automatici</span>
					<v-switch v-model="setting.corrispettiviautomatici" color="primary" class="mt-0 pt-0" hide-details></v-switch>
				</div>
				<v-select
					v-model="setting.corrispettiviautomaticistatus"
					:items="statusorders"
					item-value="_id"
					item-text="value"
					label="Status ordine che genera il corrispettivo"
					dense
					outlined
					hide-details
					background-color="white"
				/>
			</div>

			<div class="fic-section mt-4">Descrizione dei corrispettivi</div>
			<div class="fic-muted fic-small mb-2">Trascina le voci per cambiarne l'ordine; l'interruttore decide se compaiono.</div>
			<draggable :list="corrispettivi" tag="div" :sort="true" handle=".fic-grab" class="fic-lines" @change="$emit('drop', $event)">
				<div v-for="(item, index) of corrispettivi" :key="item.key || index" class="fic-line">
					<v-icon small class="fic-grab mr-2">mdi-drag-vertical</v-icon>
					<span class="fic-muted mr-2">{{ index + 1 }}</span>
					<span class="flex-grow-1 text-truncate">{{ item.key }}</span>
					<v-switch v-model="item.active" color="primary" class="mt-0 pt-0" hide-details></v-switch>
				</div>
			</draggable>
		</div>

		<div class="fic-foot">
			<v-btn small outlined color="primary" @click="$emit('authorize')"><v-icon left small>mdi-shield-key-outline</v-icon>Autorizza app</v-btn>
			<v-btn small outlined color="primary" @click="$emit('sync')"><v-icon left small>mdi-cloud-sync-outline</v-icon>Sincronizza</v-btn>
			<v-btn small outlined color="primary" @click="$emit('check')"><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn>
			<v-spacer></v-spacer>
			<v-btn small depressed color="primary" @click="$emit('save')">Salva</v-btn>
		</div>
	</div>
</template>

<script>
import Draggable from 'vuedraggable';

// riquadro di configurazione di Fatture in Cloud: riga espansa (desktop) e card (mobile).
// I campi scrivono direttamente in modello.setting; salvataggio, sincronizzazione e autorizzazione li fa la pagina.
export default {
	name: 'FattureInCloudPanel',
	components: { Draggable },
	props: {
		modello: { type: Object, required: true },
		statusorders: { type: Array, default: () => [] },
		// copia della lista per il draggable: il riordino vero lo fa la pagina sull'evento drop
		corrispettivi: { type: Array, default: () => [] },
		intestazione: { type: Boolean, default: true },
	},
	data() {
		return { mostraSecret: false };
	},
	computed: {
		setting() {
			return this.modello.setting || {};
		},
		iva() {
			return (this.setting.associates && this.setting.associates.iva) || [];
		},
		pagamenti() {
			return (this.setting.associates && this.setting.associates.payment) || [];
		},
	},
};
</script>

<style scoped>
.fic-detail {
	border: 1px solid rgba(0, 0, 0, 0.12);
	border-radius: 10px;
	overflow: hidden;
	background: #f3f6fa;
	width: 100%;
}
.fic-head {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 4px;
	padding: 8px 12px;
	background: #fff;
	border-bottom: 1px solid #e1e7ef;
	font-size: 13px;
}
.fic-head-title {
	font-weight: 600;
	color: #1f2d3d;
}
.fic-body {
	padding: 12px;
}
.fic-section {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #5f6b7a;
	margin-bottom: 6px;
}
.fic-grid {
	display: grid;
	grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
	gap: 12px 16px;
}
.fic-full {
	grid-column: 1 / -1;
}
.fic-muted {
	color: #5f6b7a;
}
.fic-small {
	font-size: 13px;
}
.fic-url {
	word-break: break-all;
}
.fic-switch {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	background: #fff;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
	padding: 6px 12px;
	font-size: 14px;
}
.fic-lines {
	background: #fff;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
	overflow: hidden;
}
.fic-line {
	display: flex;
	align-items: center;
	padding: 6px 12px;
	font-size: 14px;
}
.fic-line + .fic-line {
	border-top: 1px solid #eef2f7;
}
.fic-grab {
	cursor: grab;
}
.fic-foot {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px;
	padding: 8px 12px;
	background: #fff;
	border-top: 1px solid #e1e7ef;
}

@media (max-width: 768px) {
	.fic-body {
		padding: 8px;
	}
	.fic-grid {
		grid-template-columns: 1fr;
	}
}
</style>
